import React, { useEffect, useState } from 'react';
import { ContentCopyOutlined, CheckCircleOutlined } from '@mui/icons-material';
import { Stack, Typography, Button, Link } from '@mui/material';
import { copyTextToClipboard } from 'utils/clipboard';
import { useIsMobile } from 'hooks/useIsMobile';

type Props = {
  textToCopy: string;
  buttonText?: string;
  copiedButtonText?: string;
  small?: boolean;
  bold?: boolean;
  isLink?: boolean;
};

const defaultIcon = <ContentCopyOutlined fontSize="small" />;
const copiedIcon = <CheckCircleOutlined />;

export const CopyText = ({
  buttonText = 'link kopieren',
  copiedButtonText = 'Kopiert',
  textToCopy,
  small,
  bold,
  isLink,
}: Props) => {
  const [icon, setIcon] = useState(defaultIcon);
  const [text, setText] = useState(buttonText);
  const { isMobile } = useIsMobile();
  const largeText = bold ? 'h4' : 'body1';
  const smallText = bold ? 'h5' : 'body2';
  const textVariant = small ? smallText : largeText;

  const onCopyEmail = () => {
    copyTextToClipboard(textToCopy);
    setIcon(copiedIcon);
    setText(copiedButtonText);
  };

  useEffect(() => {
    const timeout =
      icon === copiedIcon
        ? setTimeout(() => {
            setIcon(defaultIcon);
            setText(buttonText);
          }, 3000)
        : 0;

    return () => {
      clearTimeout(timeout);
    };
  }, [buttonText, icon, text]);

  const Text = () => (
    <Typography variant={textVariant} sx={{ wordBreak: 'break-all' }}>
      {textToCopy}
    </Typography>
  );

  return (
    <Stack direction={isMobile ? 'column' : 'row'} gap={4} alignItems="center">
      {isLink ? (
        <Link sx={{ textDecoration: 'none' }} href={textToCopy} target="_blank">
          <Text />
        </Link>
      ) : (
        <Text />
      )}
      <Button
        variant="text"
        size="small"
        endIcon={icon}
        onClick={onCopyEmail}
        sx={({ spacing }) => ({ pl: 0, fontSize: spacing(3), '& .MuiButton-endIcon svg': { fontSize: spacing(4) } })}
      >
        {text}
      </Button>
    </Stack>
  );
};
